<template>
  <FormItem v-bind="itemProp">
    <div>
      <var-form-item
        style="margin-bottom: 10px"
        v-for="(item, index) in value"
        :key="index"
        :value="value[index]"
        @input="inputHandler(index, $event)"
        @delete="deleteVar(index)"
      />
      <Row>
        <Col span="22" offset="1">
          <Button type="dashed" long @click="addVar" icon="md-add">添加变量</Button>
        </Col>
      </Row>
    </div>
  </FormItem>
</template>

<script>
import VarFormItem from './VarFormItem.vue';

export default {
  components: { VarFormItem },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    formItemProps: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    itemProp() {
      return {
        label: '变量操作',
        ...this.formItemProps,
      }
    },
  },
  methods: {
    inputHandler(index, value) {
      const newValue = [...this.value];
      newValue.splice(index, 1, value);
      this.$emit('input', newValue);
    },
		// 添加变量
		addVar() {
			this.value.push({ name: '', op: '', value: '' });
      this.$emit('input', this.value);
		},
		// 删除变量
		deleteVar(index) {
			this.value.splice(index, 1);
      this.$emit('input', this.value);
		},
  }
}
</script>